import type { Outline } from "../math/samplePath";

// One closed T-rex contour: rounded head, open toothed mouth, short arm,
// two clawed feet and an upward-curving tail. Interior lines are separate.
const start = { x: 76, y: 365 };
type Command = readonly [number, number] | readonly [number, number, number, number, number, number];
const commands: readonly Command[] = [
  [45, 360, 92, 272, 139, 272],
  [169, 270, 188, 285, 218, 278],
  [251, 272, 278, 244, 300, 249],
  [324, 247, 327, 268, 354, 270],
  [408, 273, 428, 318, 441, 366],
  [454, 416, 481, 440, 534, 439],
  [607, 434, 671, 479, 728, 517],
  [757, 535, 768, 556, 795, 577],
  [883, 646, 1025, 639, 1100, 588],
  [1161, 545, 1173, 479, 1177, 434],
  [1179, 408, 1183, 403, 1192, 426],
  [1234, 537, 1184, 633, 1104, 688],
  [1027, 740, 879, 757, 757, 757],
  [781, 786, 776, 819, 808, 843],
  [830, 858, 824, 877, 823, 897],
  [817, 930, 823, 949, 836, 972],
  [852, 1004, 830, 1011, 807, 1009],
  [773, 1005, 752, 1023, 737, 1037],
  [730, 1010, 746, 985, 774, 976],
  [757, 981, 741, 999, 736, 1007],
  [707, 991, 689, 1005, 674, 1023],
  [660, 991, 684, 967, 712, 964],
  [747, 964, 760, 940, 764, 914],
  [775, 843, 710, 849, 669, 831],
  [620, 813, 594, 786, 578, 756],
  [559, 769, 562, 779, 568, 797],
  [573, 820, 559, 839, 579, 855],
  [598, 874, 572, 890, 558, 904],
  [538, 925, 538, 940, 536, 953],
  [540, 981, 511, 981, 491, 978],
  [458, 974, 443, 990, 419, 1002],
  [414, 979, 438, 952, 464, 944],
  [433, 951, 420, 963, 420, 971],
  [401, 964, 386, 975, 376, 986],
  [368, 959, 395, 936, 416, 932],
  [454, 932, 476, 922, 498, 899],
  [535, 860, 526, 845, 497, 828],
  [447, 800, 442, 763, 455, 715],
  [459, 702, 462, 694, 468, 684],
  [446, 665, 432, 654, 420, 658],
  [394, 662, 367, 646, 366, 697],
  [356, 688], [354, 710],
  [330, 692, 334, 660, 350, 645],
  [364, 630, 385, 634, 402, 629],
  [380, 608, 365, 585, 351, 562],
  [336, 536, 330, 510, 309, 493],
  [280, 471, 248, 482, 229, 487],
  [192, 497, 164, 527, 139, 519],
  [109, 511, 104, 494, 119, 483],
  [122, 459], [136, 477], [142, 450], [159, 469],
  [164, 441], [182, 459], [186, 432], [203, 444],
  [229, 430, 238, 401, 254, 391],
  [239, 385, 237, 376, 226, 369],
  [215, 360, 204, 375, 185, 377],
  [178, 399], [164, 382], [152, 401], [140, 377],
  [128, 373], [124, 396], [110, 371], [100, 368],
  [95, 391], [83, 365], [76, 365],
];

let from = start;
export const dinosaur: Outline = commands.map((command) => {
  const to = command.length === 2
    ? { x: command[0], y: command[1] }
    : { x: command[4], y: command[5] };
  const segment = {
    from,
    c1: command.length === 2 ? from : { x: command[0], y: command[1] },
    c2: command.length === 2 ? to : { x: command[2], y: command[3] },
    to,
  };
  from = to;
  return segment;
});

export const dinosaurBodyPath = `M ${start.x} ${start.y} ` +
  commands.map((command) => `${command.length === 2 ? "L" : "C"} ${command.join(" ")}`).join(" ") + " Z";
export const dinosaurDetailPaths = [
  "M 309 493 C 326 480 337 455 339 423",
  "M 345 553 C 331 566 338 593 313 589 C 283 582 267 603 267 627 C 267 640 272 648 278 656 L 280 633 L 287 642 C 283 608 307 608 322 614 C 345 622 360 602 365 591",
  "M 402 629 C 427 629 414 602 426 584",
  "M 420 658 C 445 649 457 629 463 609",
  "M 578 756 C 551 711 555 642 603 599",
  "M 757 757 C 709 753 728 723 739 710 C 748 701 751 692 754 683",
] as const;
